export default __webpack_public_path__ + "static/media/scheduled-cl.e5952f59.svg";